import { themeStyle } from '@repo/ui/theming';
import styled, { css, keyframes } from 'styled-components';

const bounce = keyframes`
  50% {
    transform: translateY(50%);
  }
`;

const animationRule = css`
  ${bounce} 1s ease infinite;
`;

export const ScrollIndicatorWrapper = styled.div<any>`
  width: 40px;
  height: 60px;
  z-index: ${themeStyle.zIndexS1};
  left: 50%;
  margin-left: -20px;
  position: fixed;
  bottom: 28px;
  border-radius: 20px;
  user-select: none;
  pointer-events: ${({ isHidden }) => (isHidden ? 'all' : 'unset')};
  touch-action: ${({ isHidden }) => (isHidden ? 'none' : 'unset')};
  cursor: ${({ isHidden }) => (isHidden ? 'auto' : 'pointer')};
  opacity: ${({ state }) =>
    ['entering', 'entered'].includes(state) ? '1' : '0'};
  transition: opacity 0.6s ease;
`;

export const ScrollIndicatorElement = styled.div`
  animation: ${animationRule};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  backdrop-filter: blur(2px);
  box-shadow:
    0px 37.5652px 102.261px rgba(0, 0, 0, 0.37),
    0px 13.7119px 37.3269px rgba(0, 0, 0, 0.3),
    0px 6.65688px 18.1215px rgba(0, 0, 0, 0.0389404),
    0px 3.26333px 8.88351px rgba(0, 0, 0, 0.0310596),
    0px 1.29032px 3.51255px rgba(0, 0, 0, 0.0217013);
`;
